import React from 'react';
import { InspirationalPicture } from 'Components/widgets/inspirational-grid/InspirationalPicture';
import type { InspirationalGridProps } from 'Components/widgets/inspirational-grid/InspirationalGrid';
import {
  getContainerStyles,
  VERTICAL_CONTAINER_RATIO,
  VERTICAL_RATIO,
} from 'Components/widgets/inspirational-grid/InspirationalGrid';
export const InspirationalGridVertical = ({ pictures }: InspirationalGridProps) => {
  const containerStyles = getContainerStyles(VERTICAL_CONTAINER_RATIO);
  const spacer = <div className="h-full w-[calc(20/1180*100%)] shrink-0" />;
  return (
    <div className="relative h-0 w-full" style={containerStyles}>
      <div className="absolute inset-0 flex justify-between">
        <InspirationalPicture
          className="w-full"
          ratioDisplay={1 / 3}
          ratioKey={VERTICAL_RATIO}
          {...pictures[0]}
          index={1}
        />
        {spacer}
        <InspirationalPicture
          className="w-full"
          ratioDisplay={1 / 3}
          ratioKey={VERTICAL_RATIO}
          {...pictures[1]}
          index={2}
        />
        {spacer}
        <InspirationalPicture
          className="w-full"
          ratioDisplay={1 / 3}
          ratioKey={VERTICAL_RATIO}
          {...pictures[2]}
          index={3}
        />
      </div>
    </div>
  );
};
